import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {LoadingCom }from '@/utils/loading.js'
import {API_URL} from '@/utils/url'
import { WebSocketSingleton } from "@/utils/websocket";
import "./assets/iconfont/iconfont.css"
Vue.prototype.loadingCom=LoadingCom
Vue.prototype.imgUrl=API_URL //全局属性(封装图片路径)
Vue.prototype.webSocket=WebSocketSingleton
WebSocketSingleton.getInstance()
Vue.config.productionTip = false

Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
Vue.prototype.openOnNewPage = function (path,id){
      // 在新页面打开
    
        let routeData = this.$router.resolve({
          path: path,
          query: {id:id}
        });
        window.open(routeData.href, '_blank');
        
}